import type { DealBookingType } from '@src/types/OTC';
import { AlertBanner, AlertVariants, Text } from '@talos/kyoko';
import { useMonitoredOTCMissingDependencies } from './useMonitoredOTCMissingDependencies';
import type { OTCMissingDependenciesLocation } from './useOTCMissingDependencies';

interface OTCMissingDependenciesBannerProps {
  location: OTCMissingDependenciesLocation;
  bookingType: DealBookingType;
}

export function OTCMissingDependenciesBanner({ location, bookingType }: OTCMissingDependenciesBannerProps) {
  const { hasMissingDependencies } = useMonitoredOTCMissingDependencies({ location, bookingType });

  if (!hasMissingDependencies) {
    return null;
  }

  return (
    <AlertBanner variant={AlertVariants.Negative}>
      <Text as="span" whiteSpace="nowrap" data-testid="otc-missing-dependencies-banner">
        Missing required Index Marks. Please contact support.
      </Text>
    </AlertBanner>
  );
}
